module.exports = __webpack_public_path__ + "img/CardImage5.469161ac.png";